// web/src/components/ui/PageHeader.tsx — the one consistent page-header pattern
// for every routed surface (M-redesign). A mono UPPERCASE kicker, a heavy title,
// a one-line purpose subtitle, and a thin emergency "hazard" rule beneath. Gives
// titles a deliberate, on-theme "emergency control panel" feel rather than a
// generic dashboard heading. Token-only styling lives in shell.css (.bgPageHeader*).
import React from 'react';

export interface PageHeaderProps {
  /** Mono UPPERCASE kicker, e.g. "VAULT", "UNSEAL REQUESTS". */
  kicker: string;
  /** Heavy page title. */
  title: string;
  /** One-line purpose / subtitle. */
  subtitle: string;
  /** Optional trailing actions (buttons), right-aligned on wide viewports. */
  actions?: React.ReactNode;
}

export function PageHeader({
  kicker,
  title,
  subtitle,
  actions,
}: PageHeaderProps): React.JSX.Element {
  return (
    <header className="bgPageHeader">
      <div className="bgPageHeaderRow">
        <div className="bgPageHeaderText">
          <span className="bgPageHeaderKicker">{kicker}</span>
          <h1 className="bgPageHeaderTitle">{title}</h1>
          <p className="bgPageHeaderSub">{subtitle}</p>
        </div>
        {actions && <div className="bgPageHeaderActions">{actions}</div>}
      </div>
      <span className="bgHazardRule" aria-hidden="true" />
    </header>
  );
}

export default PageHeader;
